/* global axios */
import ApiClient from '../ApiClient';

class PilotAssistant extends ApiClient {
  constructor() {
    super('pilot/assistants', { accountScoped: true });
  }

  get({ page = 1, search, sort } = {}) {
    const params = { page };
    if (search) params.search = search;
    if (sort) params.sort = sort;
    return axios.get(this.url, { params });
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, sortAttr = 'created_at', queryPayload, search) {
    let requestURL = `${this.url}/filter?page=${page}`;
    if (sortAttr) {
      requestURL += `&sort=${sortAttr}`;
    }
    if (search) {
      requestURL += `&search=${encodeURIComponent(search)}`;
    }
    return axios.post(requestURL, queryPayload);
  }

  create(data = {}) {
    // 如果是FormData，直接发送；否则包装在assistant对象中
    if (data instanceof FormData) {
      return axios.post(this.url, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return axios.post(this.url, {
      assistant: data,
    });
  }

  update(id, data = {}) {
    // 如果是FormData，直接发送；否则包装在assistant对象中
    if (data instanceof FormData) {
      return axios.patch(`${this.url}/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return axios.patch(`${this.url}/${id}`, {
      assistant: data,
    });
  }

  playground({ assistantId, messageContent, inboxId, conversationId }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      inbox_id: inboxId,
      conversation_id: conversationId,
    });
  }

  playgroundStartConversation({ assistantId, inboxId }) {
    return axios.post(
      `${this.url}/${assistantId}/playground_start_conversation`,
      {
        inbox_id: inboxId,
      }
    );
  }

  getPlaygroundMessages(assistantId, conversationId = null) {
    const params = {};
    if (conversationId) {
      params.conversation_id = conversationId;
    }
    return axios.get(`${this.url}/${assistantId}/playground_messages`, {
      params,
    });
  }

  // 获取预制数据（约束与安全网、回复指南）
  getPresetData() {
    return axios.get(`${this.url}/preset_data`);
  }

  // Playground 按钮转人工
  playgroundHandoff({ assistantId, conversationId }) {
    return axios.post(`${this.url}/${assistantId}/playground_handoff`, {
      conversation_id: conversationId,
    });
  }
}

export default new PilotAssistant();
